import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-measure/dist/leaflet-measure.css';
import 'leaflet-measure';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';
import 'leaflet-side-by-side';

//GeoJson Files with all the coordinates of the NUTS Layers of regions
import * as NUTS0 from 'data/NUTS/NUTS0.json';
import * as NUTS1 from 'data/NUTS/NUTS1.json';
import * as NUTS2 from 'data/NUTS/NUTS2.json';
import * as NUTS3 from 'data/NUTS/NUTS3.json';

const shapeRemover = (mapRef) => {

  // Function that loops through all layers and removes all instances of GeoJson layers
  mapRef.current.eachLayer(layer => {
    if (layer instanceof L.GeoJSON) {
      mapRef.current.removeLayer(layer); // Deleting the GeoJSON layer from the map.
      return;
    }
  });

};

const loadShapefile = (shapefile, mapRef) => {
  let highlightedLayer = null;
  shapeRemover(mapRef);

  const handleFeatureClick = (event) => {
    const layer = event.target;

    if (highlightedLayer && highlightedLayer !== layer) {
      highlightedLayer.setStyle({ color: 'black', fillColor: 'transparent' });

      if (highlightedLayer.feature) {
        highlightedLayer.feature.properties.selected = false; // Desmarcar la capa anterior
      }
    }

    const feature = layer.feature;
    if (feature) {
      layer.setStyle({ color: 'red', fillColor: 'red' });
      feature.properties.selected = true; // Marcar la capa como seleccionada
      feature.properties.level = true;
      highlightedLayer = layer;
      // console.log(`Feature ID: ${feature.id}`);
      // console.log(mapRef.current._layers);
    }
  };

  if (shapefile === 'none') {
    highlightedLayer = null;
    return;
  }

  const geoStyle = { weight: 2, color: '#305178', fillColor: 'transparent' };
  let geo;
  switch (shapefile) {
    case 'NUTS0': {
      geo = L.geoJSON(NUTS0, {
        style: geoStyle,
        onEachFeature: (feature, layer) => {
          feature.properties.nutsLevel = 'NUTS0';  // Add the property.
        }
      });
      break;
    }

    case 'NUTS1': {
      geo = L.geoJSON(NUTS1, {
        style: geoStyle,
        onEachFeature: (feature, layer) => {
          feature.properties.nutsLevel = 'NUTS1';  // Add the property.
        }
      });
      break;
    }

    case 'NUTS2': {
      geo = L.geoJSON(NUTS2, {
        style: geoStyle,
        onEachFeature: (feature, layer) => {
          feature.properties.nutsLevel = 'NUTS2';  // Add the property.
        }
      });
      break;
    }

    case 'NUTS3': {
      geo = L.geoJSON(NUTS3, {
        style: geoStyle,
        onEachFeature: (feature, layer) => {
          feature.properties.nutsLevel = 'NUTS3';  // Añadir la propiedad
        }
      });
      break;
    }

    default: return;
  }

  geo.eachLayer((layer) => {
    layer.on('click', handleFeatureClick);
  });

  geo.addTo(mapRef.current);
};

export default loadShapefile;